const ticket = {
  TICKET: 'TICKET',
  TICKETS: 'TICKETS',
  TICKETCOMMENTS: 'TICKETCOMMENTS',
  TICKETCOMMENT: 'TICKETCOMMENT',
};
export { ticket };
